import React from 'react';

import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEVersion} from '../../../react-oe/oe-version';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';
import {OEFNHelpEntryType} from '../../views/flow-nav/help/oe-flow-nav-help-model';
import {OEBayerTargetType, OEBayerTargets, OEBayerFeatureAccess, OEBayerStartSelectionData} from './oe-bayer-model';

export default class OEBayerStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.classNames = {
            [OEVersion.bayer]:      'bayer',
            [OEVersion.eyeOCT]:     'eye-oct',
            [OEVersion.knowOn]:     'know-on'
        };

        this.state = {
            className:              this.createClassName(),
            entries:                this.createEntries()
        };
    }

    componentWillReceiveProps(nextProps)   {
        if(nextProps.version !== this.props.version)  {
            this.setState({
                className:          this.createClassName(nextProps),
                entries:            this.createEntries(nextProps)
            });
        }
    }

    createClassName(props)   {
        props = props  || this.props;
        if(typeof(props.version) !== 'string')  return;
        return this.classNames[props.version];
    }

    mapTargetTypesToEntries(types)   {
        if(!Array.isArray(types))   return [];

        return types.map(targetType => {
            let pre = {type: OEProtoStartViewEntryTypes.targetType, targetType: targetType}
            
            switch(targetType)  {
                case OEBayerTargetType.anatomy:
                    return {...pre, stringId: 'target_menu_anatomy', icon: OEIconCodes.bayer.anatomyTarget, className: 'start-entry anatomy-entry'};
                case OEBayerTargetType.bayer:
                    return {...pre, stringId: 'target_menu_bayer', icon: OEIconCodes.bayer.bayerTarget, logo: 'images/logo_bayer_start_view.png', className: 'start-entry bayer-entry'};
                case OEBayerTargetType.surgery:
                    return {...pre, stringId: 'target_menu_surgery', icon: OEIconCodes.bayer.surgeryTarget, className: 'start-entry surgery-entry'};
                case OEBayerTargetType.opti:
                    return {...pre, stringId: 'target_menu_zeissOpti2', icon: OEIconCodes.bayer.optiTarget, logo: 'images/logo_zeiss.png', className: 'start-entry opti-entry'};
                case OEBayerTargetType.oct:
                    return {...pre, stringId: 'target_menu_humanEyeOCT', icon: OEIconCodes.bayer.octTarget, className: 'start-entry otc-entry'};
            }
        }).filter(e => !!e);
    }

    createEntries(props)    {
        props = props || this.props;

        let targetTypes = [OEBayerTargetType.anatomy, OEBayerTargetType.bayer, OEBayerTargetType.surgery, OEBayerTargetType.opti, OEBayerTargetType.oct];
        if(props.version === OEVersion.eyeOCT)  targetTypes = [OEBayerTargetType.anatomy, OEBayerTargetType.surgery, OEBayerTargetType.opti, OEBayerTargetType.oct];
        let targetTypeEntries = this.mapTargetTypesToEntries(targetTypes);

        let welcomeStrId = 'welcome_view_text'
        if(targetTypeEntries.length > 1 && targetTypeEntries.length < 5)    welcomeStrId = welcomeStrId + '_' + targetTypeEntries.length.toString();

        let targetTypeEntriesBayer = this.mapTargetTypesToEntries([OEBayerTargetType.bayer]);

        let entries = [
            {
                type: OEFNWelcomeEntryTypes.maskBlock,
                mask: {
                    licenseValid: true,
                    licensingAccess: (sender, entry, licensingAccess, oe) => {
                        return !(licensingAccess.isLicensing && licensingAccess.isValid && licensingAccess.edition == OELicensingEdition.viewer);
                    }
                },
                entries: [
                    {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: welcomeStrId, html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                    ...targetTypeEntries,
                    {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
                ]
            },
            {
                type: OEFNWelcomeEntryTypes.maskBlock,
                mask: {licenseValid: false},
                entries: [
                    {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                    {type: OEFNWelcomeEntryTypes.licensing, className: 'start-entry licensing-entry'},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_no_license', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                    {type: OEProtoStartViewEntryTypes.demo, targetType: OEBayerTargetType.bayer, stringId: 'target_menu_bayer', icon: OEIconCodes.bayer.bayerTarget, className: 'start-entry demo-entry'},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
                ]
            },
            {
                type: OEFNWelcomeEntryTypes.maskBlock,
                mask: {
                    licenseValid: true,
                    licensingAccess: (sender, entry, licensingAccess, oe) => {
                        return licensingAccess.isLicensing && licensingAccess.isValid && licensingAccess.edition == OELicensingEdition.viewer;
                    }
                },
                entries: [
                    {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_bayer', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                    ...targetTypeEntriesBayer,
                    {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_bayer', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                    {type: OEProtoStartViewEntryTypes.demo, targetType: OEBayerTargetType.bayer, stringId: 'target_menu_bayer', icon: OEIconCodes.bayer.bayerTarget, className: 'start-entry demo-entry'},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                    {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                    {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
                ]
            },
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'start-entry help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];

        return entries;
    }

    render()    {
        let targetTypeInfoHelp = [];
        if(OEBayerTargets.targetType(this.props.target) == OEBayerTargetType.bayer)  targetTypeInfoHelp.push({type: OEFNHelpEntryType.text, stringId: 'info_help_text_bayer'});
        if(targetTypeInfoHelp.length)   targetTypeInfoHelp.push({type: OEFNHelpEntryType.spacer, height: '1.375em' /*22*/});

        let infoHelp = {
            entries: [
                {type: OEFNHelpEntryType.spacer, height: '3.5em' /*56*/},
                ...targetTypeInfoHelp,
                {type: OEFNHelpEntryType.text, stringId: 'info_help_text'},
                {type: OEFNHelpEntryType.spacer, height: '2.5em' /*40*/},
                {type: OEFNHelpEntryType.usageRights},
                {type: OEFNHelpEntryType.licenseAgreement},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
                {type: OEFNHelpEntryType.credits},
                {type: OEFNHelpEntryType.feedback},
            ]
        };

        return (
            <OEProtoStartView
                {...this.props}
                className={this.state.className}
                entries={this.state.entries}
                infoHelp={infoHelp}
                versionTargets={OEBayerTargets}
                featureAccess={OEBayerFeatureAccess}
                startSelectionData={OEBayerStartSelectionData}
            />
        );
    }
}